import React, { Component } from 'react';

class Ipad extends Component {
  constructor(props) {
    super(props);

    var school = localStorage.getItem('school'),
        coffeeSchools = this.props.schools.filter(s=>s.coffee),
        schoolNames = coffeeSchools.map(s=>s.name);

    if(!school || schoolNames.indexOf(school) < 0)
      school = schoolNames[0]

    this.state = {
      coffees: [],
      pickupCoffees: [],
      connection_lost: true,
      school: school,
      coffeeSchools: coffeeSchools,
      audioEnabled: false
    }
    this.pollCoffees()

    this.alertSound = document.getElementById('alertsound')
  }

  pollCoffees(){
    fetch('/api/order/coffees', {credentials: 'include'})
      .then(res => {
        if(res.ok)
          return res.json()
        else
          throw new Error('Network response was not ok.');
      })
      .then(x=>{
          var newCoffees = x.filter(c=>[null, 'new'].indexOf(c.status) > -1),
            pickupCoffees = x.filter(c=>c.status==='pickup');

          if(this.state.audioEnabled && newCoffees.length > this.state.coffees.length)
            this.alertSound.play()

          this.setState({
            coffees: newCoffees,
            pickupCoffees: pickupCoffees,
            connection_lost: false
          });
        })
      .catch(error=> {
        console.log('error', error);
        this.setState({error: error.toString(), connection_lost: true})
      });
  }

  enableAudio(e){
    e.preventDefault();
    this.alertSound.play()
    this.setState({audioEnabled: true})
  }

  componentDidMount(){
    this.pollInterval = setInterval(this.pollCoffees.bind(this), 5000)
  }

  componentWillUnmount(){
    clearInterval(this.pollInterval)
  }

  filteredCoffees(){
    return this.state.coffees.filter(coffee=>
      coffee.school === this.state.school
    )
  }
  filteredPickupCoffees(){
    return this.state.pickupCoffees.filter(coffee=>
      coffee && (coffee.school === this.state.school)
    )
  }

  handleCompleted(id, e){
    e.preventDefault();
    //Post the data
    fetch('/api/order/coffees/complete', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({id: id}),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => {
      if(res.ok){
        var coffee = this.state.coffees.find(c=>c.id === id),
            coffees = this.state.coffees.filter(c=>c.id !== id),
            pickupCoffees = this.state.pickupCoffees;
        pickupCoffees.push(coffee);
        this.setState({coffees: coffees, pickupCoffees: pickupCoffees});
      }
      else
        throw new Error('Network response was not ok.');
    })
  }

  handleChange(e){
    if(e.target.name === 'school')
      localStorage.setItem('school', e.target.value)
    var news = {}
    news[e.target.name] = e.target.value
    this.setState(news)
  }

  handlePickedup(id, e){
    e.preventDefault();
    //Post the data
    fetch('/api/order/coffees/pickedup', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({id: id}),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    }).then(res => {
      if(res.ok){
        var coffees = this.state.pickupCoffees.filter(c=>c.id !== id);
        this.setState({pickupCoffees: coffees});
      }
      else
        throw new Error('Network response was not ok.');
    })
  }

  render() {
    return (
      <div className="container">
        { this.state.audioEnabled ? null : (
          <div className="alert alert-danger">
            Audio alerts not enabled
            <button className="btn btn-danger pull-right" onClick={this.enableAudio.bind(this)}>
              Enable Audio
            </button>
            <br />
            <br />
          </div>
        )}
        <h1>Coffee Orders</h1>
        <select name="school"
          className="form-control"
          value={this.state.school}
          onChange={this.handleChange.bind(this)}>
            { this.state.coffeeSchools.map(school=>(
              <option key={school.id}>{school.name}</option>
            ))}
        </select>

        { this.state.connection_lost ? (
          <p>
            Connection to server lost, coffee
            queue unknown. Attempting to reconnect...
          </p>
        ) : null }

        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Coffee</th>
              <th>Ordered By</th>
              <th>Ordered At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            { this.filteredCoffees().map(coffee=>(
              <tr key={coffee.id}>
                <td>{coffee.id % 100}</td>
                <td>{coffee.coffees.map(cof=>(
                  <p key={cof}>{cof}</p>
                ))}</td>
                <td>{coffee.person}</td>
                <td>{coffee.createdAt}</td>
                <td>
                  <button
                    onClick={this.handleCompleted.bind(this, coffee.id)}
                    className="btn btn-primary btn-sm">
                    Complete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        { this.filteredCoffees().length === 0 ? (
          <div><div className="well">No new coffee orders</div><br /></div>
        ) : null}

        <h1>Coffee Ready for pickup</h1>

        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Coffee</th>
              <th>Ordered By</th>
              <th>Ordered At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            { this.filteredPickupCoffees().map(coffee=>(
              <tr key={coffee.id}>
                <td>{coffee.id % 100}</td>
                <td>{coffee.coffees && coffee.coffees.map(cof=>(
                  <p key={cof}>{cof}</p>
                ))}</td>
                <td>{coffee.person}</td>
                <td>{coffee.createdAt}</td>
                <td>
                  <button
                    onClick={this.handlePickedup.bind(this, coffee.id)}
                    className="btn btn-primary btn-sm">
                    Picked Up
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        { this.filteredPickupCoffees().length === 0 ? (
          <div><div className="well">No orders ready for pickup</div><br /></div>
        ) : null}

      </div>
    );
  }
}

export default Ipad;



// WEBPACK FOOTER //
// ./src/pages/Ipad.js